export interface CurrencyFormat {
	symbol: string;
	position: 'prefix' | 'suffix';
}

export const currencyFormats: { [k: string]: CurrencyFormat } = {
	USD: { symbol: '$', position: 'prefix' }, // US Dollar
	CAD: { symbol: '$', position: 'prefix' }, // Canadian Dollar
	AED: { symbol: 'د.إ', position: 'suffix' }, // United Arab Emirates Dirham
	AFN: { symbol: '؋', position: 'prefix' }, // Afghan Afghani
	ALL: { symbol: 'L', position: 'prefix' }, // Albanian Lek
	AMD: { symbol: '֏', position: 'prefix' }, // Armenian Dram
	ANG: { symbol: 'ƒ', position: 'prefix' }, // Netherlands Antillean Guilder
	AOA: { symbol: 'Kz', position: 'prefix' }, // Angolan Kwanza
	ARS: { symbol: '$', position: 'prefix' }, // Argentine Peso
	AUD: { symbol: '$', position: 'prefix' }, // Australian Dollar
	AWG: { symbol: 'ƒ', position: 'prefix' }, // Aruban Florin
	AZN: { symbol: '₼', position: 'prefix' }, // Azerbaijani Manat
	BAM: { symbol: 'KM', position: 'suffix' }, // Bosnia & Herzegovina Convertible Mark
	BBD: { symbol: '$', position: 'prefix' }, // Barbadian Dollar
	BDT: { symbol: '৳', position: 'prefix' }, // Bangladeshi Taka
	BGN: { symbol: 'лв', position: 'suffix' }, // Bulgarian Lev
	BIF: { symbol: 'FBu', position: 'prefix' }, // Burundian Franc
	BMD: { symbol: '$', position: 'prefix' }, // Bermudian Dollar
	BND: { symbol: '$', position: 'prefix' }, // Brunei Dollar
	BOB: { symbol: 'Bs', position: 'prefix' }, // Bolivian Boliviano
	BRL: { symbol: 'R$', position: 'prefix' }, // Brazilian Real
	BSD: { symbol: '$', position: 'prefix' }, // Bahamian Dollar
	BWP: { symbol: 'P', position: 'prefix' }, // Botswana Pula
	BZD: { symbol: '$', position: 'prefix' }, // Belize Dollar
	CDF: { symbol: 'FC', position: 'prefix' }, // Congolese Franc
	CHF: { symbol: 'CHF', position: 'suffix' }, // Swiss Franc
	CLP: { symbol: '$', position: 'prefix' }, // Chilean Peso
	CNY: { symbol: '¥', position: 'prefix' }, // Chinese Yuan
	COP: { symbol: '$', position: 'prefix' }, // Colombian Peso
	CRC: { symbol: '₡', position: 'prefix' }, // Costa Rican Colón
	CVE: { symbol: 'Esc', position: 'prefix' }, // Cape Verdean Escudo
	CZK: { symbol: 'Kč', position: 'suffix' }, // Czech Koruna
	DJF: { symbol: 'Fdj', position: 'prefix' }, // Djiboutian Franc
	DKK: { symbol: 'kr', position: 'suffix' }, // Danish Krone
	DOP: { symbol: 'RD$', position: 'prefix' }, // Dominican Peso
	DZD: { symbol: 'د.ج', position: 'suffix' }, // Algerian Dinar
	EGP: { symbol: '£', position: 'prefix' }, // Egyptian Pound
	ETB: { symbol: 'Br', position: 'prefix' }, // Ethiopian Birr
	EUR: { symbol: '€', position: 'suffix' }, // Euro
	FJD: { symbol: '$', position: 'prefix' }, // Fijian Dollar
	FKP: { symbol: '£', position: 'prefix' }, // Falkland Islands Pound
	GBP: { symbol: '£', position: 'prefix' }, // British Pound
	GEL: { symbol: '₾', position: 'prefix' }, // Georgian Lari
	GIP: { symbol: '£', position: 'prefix' }, // Gibraltar Pound
	GMD: { symbol: 'D', position: 'prefix' }, // Gambian Dalasi
	GNF: { symbol: 'FG', position: 'prefix' }, // Guinean Franc
	GTQ: { symbol: 'Q', position: 'prefix' }, // Guatemalan Quetzal
	GYD: { symbol: '$', position: 'prefix' }, // Guyanese Dollar
	HKD: { symbol: 'HK$', position: 'prefix' }, // Hong Kong Dollar
	HNL: { symbol: 'L', position: 'prefix' }, // Honduran Lempira
	HRK: { symbol: 'kn', position: 'suffix' }, // Croatian Kuna
	HTG: { symbol: 'G', position: 'prefix' }, // Haitian Gourde
	HUF: { symbol: 'Ft', position: 'suffix' }, // Hungarian Forint
	IDR: { symbol: 'Rp', position: 'prefix' }, // Indonesian Rupiah
	ILS: { symbol: '₪', position: 'prefix' }, // Israeli New Shekel
	INR: { symbol: '₹', position: 'prefix' }, // Indian Rupee
	ISK: { symbol: 'kr', position: 'suffix' }, // Icelandic Króna
	JMD: { symbol: '$', position: 'prefix' }, // Jamaican Dollar
	JPY: { symbol: '¥', position: 'prefix' }, // Japanese Yen
	KES: { symbol: 'KSh', position: 'prefix' }, // Kenyan Shilling
	KGS: { symbol: 'сом', position: 'prefix' }, // Kyrgyzstani Som
	KHR: { symbol: '៛', position: 'prefix' }, // Cambodian Riel
	KRW: { symbol: '₩', position: 'prefix' }, // South Korean Won
	KWD: { symbol: 'د.ك', position: 'suffix' }, // Kuwaiti Dinar
	KYD: { symbol: '$', position: 'prefix' }, // Cayman Islands Dollar
	KZT: { symbol: '₸', position: 'prefix' }, // Kazakhstani Tenge
	LAK: { symbol: '₭', position: 'prefix' }, // Lao Kip
	LBP: { symbol: 'ل.ل', position: 'suffix' }, // Lebanese Pound
	LKR: { symbol: 'Rs', position: 'prefix' }, // Sri Lankan Rupee
	LRD: { symbol: '$', position: 'prefix' }, // Liberian Dollar
	LSL: { symbol: 'L', position: 'prefix' }, // Lesotho Loti
	LYD: { symbol: 'ل.د', position: 'suffix' }, // Libyan Dinar
	MAD: { symbol: 'د.م.', position: 'suffix' }, // Moroccan Dirham
	MDL: { symbol: 'L', position: 'prefix' }, // Moldovan Leu
	MGA: { symbol: 'Ar', position: 'prefix' }, // Malagasy Ariary
	MKD: { symbol: 'ден', position: 'prefix' }, // Macedonian Denar
	MMK: { symbol: 'K', position: 'prefix' }, // Myanmar Kyat
	MNT: { symbol: '₮', position: 'prefix' }, // Mongolian Tögrög
	MOP: { symbol: 'MOP$', position: 'prefix' }, // Macanese Pataca
	MRU: { symbol: 'UM', position: 'prefix' }, // Mauritanian Ouguiya
	MUR: { symbol: '₨', position: 'prefix' }, // Mauritian Rupee
	MVR: { symbol: 'Rf', position: 'prefix' }, // Maldivian Rufiyaa
	MWK: { symbol: 'MK', position: 'prefix' }, // Malawian Kwacha
	MXN: { symbol: '$', position: 'prefix' }, // Mexican Peso
	MYR: { symbol: 'RM', position: 'prefix' }, // Malaysian Ringgit
	MZN: { symbol: 'MT', position: 'prefix' }, // Mozambican Metical
	NAD: { symbol: '$', position: 'prefix' }, // Namibian Dollar
	NGN: { symbol: '₦', position: 'prefix' }, // Nigerian Naira
	NIO: { symbol: 'C$', position: 'prefix' }, // Nicaraguan Córdoba
	NOK: { symbol: 'kr', position: 'suffix' }, // Norwegian Krone
	NPR: { symbol: '₨', position: 'prefix' }, // Nepalese Rupee
	NZD: { symbol: '$', position: 'prefix' }, // New Zealand Dollar
	OMR: { symbol: 'ر.ع.', position: 'suffix' }, // Omani Rial
	PAB: { symbol: 'B/.', position: 'prefix' }, // Panamanian Balboa
	PEN: { symbol: 'S/.', position: 'prefix' }, // Peruvian Sol
	PGK: { symbol: 'K', position: 'prefix' }, // Papua New Guinean Kina
	PHP: { symbol: '₱', position: 'prefix' }, // Philippine Peso
	PKR: { symbol: '₨', position: 'prefix' }, // Pakistani Rupee
	PLN: { symbol: 'zł', position: 'suffix' }, // Polish Złoty
	PYG: { symbol: '₲', position: 'prefix' }, // Paraguayan Guaraní
	QAR: { symbol: 'ر.ق', position: 'suffix' }, // Qatari Riyal
	RON: { symbol: 'lei', position: 'suffix' }, // Romanian Leu
	RSD: { symbol: 'дин', position: 'suffix' }, // Serbian Dinar
	RUB: { symbol: '₽', position: 'suffix' }, // Russian Ruble
	RWF: { symbol: 'RF', position: 'prefix' }, // Rwandan Franc
	SAR: { symbol: 'ر.س', position: 'suffix' }, // Saudi Riyal
	SBD: { symbol: '$', position: 'prefix' }, // Solomon Islands Dollar
	SCR: { symbol: '₨', position: 'prefix' }, // Seychellois Rupee
	SDG: { symbol: '£', position: 'prefix' }, // Sudanese Pound
	SEK: { symbol: 'kr', position: 'suffix' }, // Swedish Krona
	SGD: { symbol: 'S$', position: 'prefix' }, // Singapore Dollar
	SHP: { symbol: '£', position: 'prefix' }, // Saint Helena Pound
	SLL: { symbol: 'Le', position: 'prefix' }, // Sierra Leonean Leone
	SOS: { symbol: 'S', position: 'prefix' }, // Somali Shilling
	SRD: { symbol: '$', position: 'prefix' }, // Surinamese Dollar
	SSP: { symbol: '£', position: 'prefix' }, // South Sudanese Pound
	STN: { symbol: 'Db', position: 'prefix' }, // São Tomé and Príncipe Dobra
	SVC: { symbol: '₡', position: 'prefix' }, // Salvadoran Colón
	SYP: { symbol: '£', position: 'prefix' }, // Syrian Pound
	SZL: { symbol: 'L', position: 'prefix' }, // Swazi Lilangeni
	THB: { symbol: '฿', position: 'prefix' }, // Thai Baht
	TJS: { symbol: 'ЅМ', position: 'prefix' }, // Tajikistani Somoni
	TMT: { symbol: 'm', position: 'prefix' }, // Turkmenistani Manat
	TND: { symbol: 'د.ت', position: 'suffix' }, // Tunisian Dinar
	TOP: { symbol: 'T$', position: 'prefix' }, // Tongan Paʻanga
	TRY: { symbol: '₺', position: 'prefix' }, // Turkish Lira
	TTD: { symbol: '$', position: 'prefix' }, // Trinidad and Tobago Dollar
	TWD: { symbol: 'NT$', position: 'prefix' }, // New Taiwan Dollar
	TZS: { symbol: 'Sh', position: 'prefix' }, // Tanzanian Shilling
	UAH: { symbol: '₴', position: 'prefix' }, // Ukrainian Hryvnia
	UGX: { symbol: 'USh', position: 'prefix' }, // Ugandan Shilling
	UYU: { symbol: '$', position: 'prefix' }, // Uruguayan Peso
	UZS: { symbol: 'сўм', position: 'prefix' }, // Uzbekistani Som
	VEF: { symbol: 'Bs', position: 'prefix' }, // Venezuelan Bolívar
	VND: { symbol: '₫', position: 'suffix' }, // Vietnamese Đồng
	VUV: { symbol: 'Vt', position: 'prefix' }, // Vanuatu Vatu
	WST: { symbol: 'T', position: 'prefix' }, // Samoan Tala
	XAF: { symbol: 'FCFA', position: 'suffix' }, // Central African CFA Franc
	XCD: { symbol: '$', position: 'prefix' }, // East Caribbean Dollar
	XOF: { symbol: 'CFA', position: 'suffix' }, // West African CFA Franc
	XPF: { symbol: 'CFP', position: 'suffix' }, // CFP Franc
	YER: { symbol: '﷼', position: 'prefix' }, // Yemeni Rial
	ZAR: { symbol: 'R', position: 'prefix' }, // South African Rand
	ZMW: { symbol: 'ZK', position: 'prefix' } // Zambian Kwacha
};
